export default "__VITE_ASSET__DpsGgxJc__"